const $ = require('jquery');
const Mn = require('backbone.marionette');
const Template = require('balus/ui/template/nav-width-changer.hbs');

$('head').append($('<style id="nav-style">#nav {}</style>'));

module.exports = Mn.View.extend({
    template: Template,
    ui: {
        changer: '#nav-width-changer'
    },
    events: {
        'mousedown @ui.changer': 'startResize'
    },

    initialize: function() {
        _.bindAll(this, 'resize', 'endResize');
        this._ondrag = false;
    },

    onDomRefresh: function() {
        this._width = $('#nav').width();
    },

    startResize: function(e) {
        this._ondrag = true;
        this._startX = e.clientX;

        $(window).on('mousemove', this.resize);
        $(window).on('mouseup', this.endResize);
    },

    resize: function(e) {
        e.preventDefault();
        if(this._ondrag) {
            var dX = e.clientX - this._startX;
            this._startX = e.clientX;
            this._width += dX;

            this.setStyle();
        }
    },

    setStyle: function() {
        if(this._width < 2) {
            this._width = 2;
        }

        const width = this._width / $(window).width() * 100;

        $('#nav-style').html(`@media screen and (min-width: 768px) { #nav { width: ${width}%;}}`);
    },

    endResize: function() {
        this._ondrag = false;
        $(window).off('mousemove', this.resize);
        $(window).off('mouseup', this.endResize);
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/nav-width-changer.js